import { isEmbarcacaoAcomodacoesEmpty } from "@/modules/embarcacoes/embarcacoes.types";
import type {
  EmbarcacaoAcomodacoes,
  EmbarcacaoAcomodacoesState,
} from "@/modules/embarcacoes/embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

const ACOMODACOES_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoAcomodacoes> = {
  select: (ficha) => ficha.acomodacoes,
  isEmpty: isEmbarcacaoAcomodacoesEmpty,
  secao: "as Acomodações",
};

interface UseEmbarcacaoAcomodacoesResult extends EmbarcacaoAcomodacoesState {
  reload: () => void;
}

/**
 * Consulta as Acomodações da embarcação pedida (AC4). Somente leitura: nenhuma
 * escrita é disparada na abertura nem no fechamento do modal.
 */
export function useEmbarcacaoAcomodacoes(id: string): UseEmbarcacaoAcomodacoesResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, ACOMODACOES_QUERY);

  return { ...state, acomodacoes: data };
}
